import {fr} from 'yup-locales';
import {setLocale} from 'yup';

export default function () {
  setLocale(fr);
}
